<template>
    <div class="page-container">
        <div class="page-content">
            <div class="content-wrapper">
                <div class="panel panel-flat blog-pinned">
                    <div class="panel-heading">
                        <h6 class="panel-title">Pursuing.business</h6>

                        <div class="heading-elements">
                            <span class="label label-default">Pinned</span>
                        </div>
                    </div>

                    <div class="media panel-body no-margin">
                        <div class="media-left hidden-xs">
                            <a>
                                <img src="/assets/img/macbook.jpg"
                                     style="width: 68px; height: 68px;" class="img-circle" alt="">
                            </a>
                        </div>
                        <div class="media-body">
                            <h6 class="media-heading text-semibold">Last 365 days of My Twenties</h6>
                            <p>When you're going to change major number of your age it's ok to evaluate your last
                                decade. So, all my twenties I was dreaming to realise some idea: find some problem which
                                people are facing and solve it with some great product.<br/>
                                I am 29 now and I still not accomplished it.
                                I don't have exact plan how to achieve it yet, but I will keep going until I
                                succeed.<br/>
                                Here I will be posting steps taken, lessons learned and just things which inspired me
                                along the way.<br/>
                                Hope you will grab something useful and inspiring ;)</p>
                        </div>
                    </div>
                </div>
                <hr/>
                <button v-if="postId" class="btn btn-default" @click="showAllPosts" style="margin-bottom: 15px"><i
                    class="fas fa-long-arrow-alt-left" style="margin-right: 5px"></i> Show all posts</button>
                <new-blog-item v-if="showNewItemBlock" @blogItemAdded="addBlogItem"/>
                <blog-item v-for="(blogItem, i) in filterItems" :blogItem="blogItem" :key="i" :postId="postId"
                           :postToggled="postToggled" @togglePost="togglePost"/>
                <div v-if="filterItems.length === 0" class="alert bg-grey-300 no-border text-center">No any posts yet</div>
            </div>
            <!-- Opposite sidebar -->
            <div class="sidebar sidebar-opposite sidebar-default sidebar-separate">
                <div class="sidebar-content">
                    <div class="sidebar-category text-center">
                        <div class="category-content">
                            <div class="media no-margin">
                                <div class="media-body">
                                    <h3 class="no-margin text-semibold">{{ timer }}</h3>
                                    <span class="text-uppercase text-size-mini text-muted">days left</span>
                                    <div class="progress content-group-sm" style="width: 100%">
                                        <div class="progress-bar progress-bar-primary" data-transitiongoal-backup="75"
                                             data-transitiongoal="75" :style="{width: percent}">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="loggedIn" class="sidebar-category">
                        <div class="category-title">
                            <span>New Post</span>
                        </div>

                        <div class="category-content">
                            <a class="btn btn-primary btn-block" @click="showNewItemBlock = !showNewItemBlock"><i
                                    class="fas fa-pencil-alt"></i> Create</a>
                        </div>
                    </div>

                    <div class="sidebar-category">
                        <div class="category-title">
                            <span>Subscribe to Updates</span>
                        </div>

                        <div class="category-content">
                            <div class="input-group">
                                <input type="text" class="form-control" placeholder="me@example.com" v-model="subscribeMail">
                                <span class="input-group-btn">
                                    <button class="btn btn-primary" type="button" @click="processSubscription">Add me</button>
                                </span>
                            </div>
                            <span class="text-muted" style="padding-left:10px">*Only once a week</span>

                        </div>
                    </div>

                    <div class="sidebar-category">
                        <div class="category-title">
                            <span>Share</span>
                        </div>

                        <div class="category-content no-padding-bottom text-center">
                            <ul class="list-inline no-margin">
                                <li>
                                    <a href="https://www.facebook.com/sharer/sharer.php?u=pursuing.business" target="_blank"
                                       class="btn bg-indigo btn-icon content-group">
                                        <i class="fab fa-facebook"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/intent/tweet?text=Last%20365%20days%20of%20My%20Twenties%0Ahttps://pursuing.business"
                                       class="btn bg-info btn-icon content-group">
                                        <i class="fab fa-twitter"></i>
                                    </a>
                                </li>
                                <li>
                                    <a class="btn bg-orange btn-icon content-group" @click="addToBookmark">
                                        <i class="fas fa-bookmark"></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="sidebar-category">
                        <div class="category-title">
                            <span>Tags</span>
                        </div>

                        <div class="category-content no-padding-bottom">
                            <ul class="list-inline list-inline-condensed no-margin-bottom">
                                <li v-for="pTag in predefinedTags" @click="onTagClicked($event, pTag)">
                                    <a>
                                        <span class="label border-left-blue label-striped content-group"
                                              :class="{'active': selectedTag === pTag}">{{pTag}}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="sidebar-category">
                        <div class="category-title">
                            <span>Archive</span>
                        </div>

                        <div class="category-content no-padding">
                            <ul class="navigation">
                                <li v-for="(month, m) in mnths" @click="onMonthFilterClicked($event, m)" :class="{'active': filterMonth === m}"><a>{{month}}</a></li>
                            </ul>
                        </div>
                    </div>

                    <div class="sidebar-category">
                        <div class="category-title">
                            <span>Search</span>
                        </div>

                        <div class="category-content">
                            <form action="#">
                                <div class="has-feedback has-feedback-left">
                                    <input type="search" class="form-control" placeholder="Search" v-model="searchq">
                                    <div class="form-control-feedback">
                                        <i class="fas fa-search text-size-base text-muted"></i>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import router from '../../router/router.js'
  import swal from 'sweetalert2'
  import db from '../../db.js'
  import NewBlogItem from './NewBlogItem.vue'
  import BlogItem from './BlogItem.vue';


  let itemsRef = {
    public: db.ref('blog-items/public')
  };

  export default {
    name: 'blog-main',
    components: {
      BlogItem,
      NewBlogItem
    },
    computed: {
      ...mapState(['mode', 'loggedIn']),
      ...mapGetters(['getUser']),
      timer() {
        let today = new Date()
        let one_day = 1000 * 60 * 60 * 24;
        let end = new Date(today.getFullYear(), 2, 15)
        end.setFullYear(end.getFullYear() + 1)
        return Math.ceil((end.getTime() - today.getTime()) / (one_day))
      },
      percent() {
        return ((this.timer / 365) * 100) + '%'
      },
      filterItems() {
        let items = this.blogItems.slice().reverse()
        if (this.postId && this.postId !== '') {
          return items.filter(item => item['id'] === this.postId)
        }
        if (this.filterMonth !== '') {
          return items.filter(item => new Date(item.date).getMonth() === Number(this.filterMonth))
        }
        if (this.searchq !== '') {
          return items.filter(item => item.content.indexOf(this.searchq) > -1)
        }
        if (this.selectedTag !== '') {
          return items.filter(item => item.tags.indexOf(this.selectedTag) > -1)
        }
        return items
      }
    },
    data() {
      return {
        predefinedTags: ['ideas', 'market', 'business plan', 'finance', 'product', 'marketing', 'experience', 'inspiration', 'team', 'lean startup', 'graphic', 'video'],
        mnths: ['January', 'February', 'March'],
        showNewItemBlock: false,
        postToggled: 0,
        subscribeMail: '',
        postId: this.$route.params.id,
        selectedTag: '',
        searchq: '',
        filterMonth: ''
      }
    },
    firebase: {
      blogItems: {
        source: itemsRef['public'],
        readyCallback: function () {
          this.changeMetaTags()
        }},
      subscriptions: db.ref('subscriptions')
    },
    mounted() {
      document.body.classList.add('sidebar-opposite-visible');
    },
    destroyed() {
      document.body.classList.remove('sidebar-opposite-visible');
    },
    methods: {
      changeMetaTags () {
        if (this.postId && this.postId !== '') {
          const item = this.blogItems.filter(item => item['id'] === this.postId);
          if (item && item.length > 0) {
            document.head.querySelector("meta[property='og:url']").content = `https://pursuing.business/post/${item[0].id}`
            document.head.querySelector("meta[property='og:title']").content = `Starting business from zero: ${item[0].title}`
            document.head.querySelector("meta[property='description']").content = item[0].description
            document.head.querySelector("meta[property='og:description']").content = item[0].description
            document.head.querySelector("meta[property='og:image']").content = item[0].image
          }
        }
      },
      addBlogItem(item) {
        itemsRef[this.mode].push(item);
        this.showNewItemBlock = false
      },
      showAllPosts () {
        this.postId = null
        router.push({ path: '/' })
      },
      togglePost () {
        this.postToggled = this.postToggled + 1
      },
      onTagClicked(ev, tag) {
        if (this.selectedTag === tag) {
          this.selectedTag = ''
          return
        }
        this.selectedTag = tag
      },
      onMonthFilterClicked(ev, month) {
        if (this.filterMonth === month) {
          this.filterMonth = ''
          return
        }
        this.filterMonth = month
      },
      processSubscription () {
        const sub = {
          email: this.subscribeMail,
          subscribed: true,
          date: new Date()
        }
        this.$firebaseRefs.subscriptions.push(sub)
        swal(
          'You are in!',
          'Thank you for subscribing',
          'success')
        this.subscribeMail = ''
      },
      addToBookmark(e) {
        e.preventDefault();
        var bookmarkURL = window.location.href;
        var bookmarkTitle = document.title;

        if ('addToHomescreen' in window && window.addToHomescreen.isCompatible) {
          // Mobile browsers
          addToHomescreen({autostart: false, startDelay: 0}).show(true);
        } else if (window.sidebar && window.sidebar.addPanel) {
          // Firefox version < 23
          window.sidebar.addPanel(bookmarkTitle, bookmarkURL, '');
        } else if ((window.sidebar && /Firefox/i.test(navigator.userAgent)) || (window.opera && window.print)) {
          // Firefox version >= 23 and Opera Hotlist
          $(this).attr({
            href: bookmarkURL,
            title: bookmarkTitle,
            rel: 'sidebar'
          }).off(e);
          return true;
        } else if (window.external && ('AddFavorite' in window.external)) {
          // IE Favorite
          window.external.AddFavorite(bookmarkURL, bookmarkTitle);
        } else {
          // Other browsers (mainly WebKit - Chrome/Safari)
          alert('Please press ' + (/Mac/i.test(navigator.userAgent) ? '⌘' : 'Strg') + ' + D to add this page to your favorites.');
        }

        return false;
      }
    }
  }
</script>

<style>
    .blog-title {
        margin-top: 0;
    }

    .label.active {
        background-color: #03A9F4;
    }

    .panel-footer {
        background-color: #fff;
    }

    .blog-pinned > .panel-heading > .panel-title > .heading-elements-toggle {
        display: none !important;
    }
</style>



// WEBPACK FOOTER //
// BlogMain.vue?27a15dfb